import(/* webpackMode: "eager" */ "/vercel/path0/src/app/de/blog/page.tsx");
